import DraggableStepCard from '../../DraggableStepCard';

import { getDescriptionValue } from 'pages/AutomationEngine/Engine/Steps/type/variable/getDescriptionValue';

export const content = ({ step }) => step.description;

export const getDescription = ({ step: { details }, t }) => {
  const { descriptionValue, descriptionPlural } = getDescriptionValue({
    details,
    t,
  });
  return t(`%{variableName}% = %{descriptionValue}%%{descriptionPlural}%`, {
    interpolation: { prefix: '%{', suffix: '}%' },
    variableName: details.chosenVariable?.label,
    descriptionValue,
    descriptionPlural,
  });
};
export default function UpdateVariableCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
